// src/components/Header.jsx
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import { registerUser } from '../../services/authService';
import { Button, NavDropdown, Modal, Form } from 'react-bootstrap';

function Header() {
  const { getCartItemCount } = useCart();
  const { isAuthenticated, user, login, logout, isLoading, checkAuth } = useAuth();
  const totalItems = getCartItemCount();
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState('');

  // States cho Login
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');

  // States cho Register
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [registerData, setRegisterData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '', // THAY ĐỔI: Thêm trường phone
    address: '', // THAY ĐỔI: Thêm trường address
  });
  const [registerError, setRegisterError] = useState('');
  const [registerSuccess, setRegisterSuccess] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);

  // useEffect(() => {
  //   // Optional: call checkAuth if not handled globally in App.js
  //   // checkAuth();
  // }, [checkAuth]);


  const handleProtectedLinkClick = (e, path) => {
    if (!isAuthenticated) {
      e.preventDefault();
      openLoginModal();
    } else {
      navigate(path);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?name=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  };

  const openLoginModal = () => {
    setLoginData({ username: '', password: '' });
    setLoginError('');
    // Không reset registerSuccess ở đây, để người dùng thấy nếu vừa đăng ký xong
    setShowRegisterModal(false); // Đảm bảo modal đăng ký đóng
    setShowLoginModal(true);
  };

  const openRegisterModal = () => {
    setRegisterData({
      fullName: '',
      email: '',
      password: '',
      confirmPassword: '',
      phone: '',
      address: '',
    });
    setRegisterError('');
    setRegisterSuccess('');
    setShowLoginModal(false); // Đảm bảo modal đăng nhập đóng
    setShowRegisterModal(true);
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    setRegisterSuccess(''); 
    try {
      const loggedInUser = await login(loginData);
      setShowLoginModal(false);
      if (loggedInUser.role === 'ADMIN') {
        navigate('/admin');
      }
    } catch (err) {
      setLoginError(err.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.');
    }
  };

  const handleRegisterChange = (e) => {
    setRegisterData({ ...registerData, [e.target.name]: e.target.value });
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    setRegisterError('');
    setRegisterSuccess('');

    if (registerData.password !== registerData.confirmPassword) {
      setRegisterError('Mật khẩu và xác nhận mật khẩu không khớp.');
      return;
    }

    setIsRegistering(true);
    try {
      // Chuẩn bị payload theo yêu cầu, bao gồm cả các trường tùy chọn
      const payload = {
        email: registerData.email.trim(),
        fullName: registerData.fullName.trim(),
        password: registerData.password, // Mật khẩu không nên trim
        confirmPassword: registerData.confirmPassword, // Mật khẩu không nên trim
      };
      // Chỉ thêm phone và address vào payload nếu chúng có giá trị
      if (registerData.phone.trim()) {
        payload.phone = registerData.phone.trim();
      }
      if (registerData.address.trim()) {
        payload.address = registerData.address.trim();
      }
      
      await registerUser(payload); 

      setRegisterSuccess('Đăng ký thành công! Bạn có thể đăng nhập ngay bây giờ.');
      setShowRegisterModal(false);
      openLoginModal();
      
    } catch (err) {
      // registerUser đã throw Error với message phù hợp
      setRegisterError(err.message || 'Đã xảy ra lỗi trong quá trình đăng ký.');
    } finally {
      setIsRegistering(false);
    }
  };

  return (
    <header className="bg-danger text-white shadow-sm sticky-top">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-dark">
          <Link to="/" className="navbar-brand fw-bold fs-4">
            AE Rọt Shop
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <div className="mx-auto my-2 my-lg-0" style={{ width: '50%' }}>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Tìm kiếm laptop..."
                  aria-label="Tìm kiếm sản phẩm"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button className="btn btn-light" type="button" onClick={handleSearch}>
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>

            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item me-3">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? 'nav-link active text-warning' : 'nav-link text-white'
                  }
                >
                  <i className="bi bi-house-door me-1"></i> Trang chủ
                </NavLink>
              </li>

              <li className="nav-item me-3">
                <Link
                  to="/cart"
                  onClick={(e) => handleProtectedLinkClick(e, '/cart')}
                  className="nav-link text-white position-relative"
                >
                  <i className="bi bi-cart me-1"></i> Giỏ hàng
                  {totalItems > 0 && (
                    <span
                      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                      style={{ fontSize: '0.65rem' }}
                    >
                      {totalItems}
                    </span>
                  )}
                </Link>
              </li>

              {isLoading && !isAuthenticated ? (
                <li className="nav-item">
                  <span className="nav-link text-white">Đang tải...</span>
                </li>
              ) : isAuthenticated ? (
                <NavDropdown
                  title={
                    <>
                      <i className="bi bi-person-circle me-1"></i>
                      {user?.fullName || user?.name || user?.username || 'Tài khoản'}
                    </>
                  }
                  id="basic-nav-dropdown"
                  menuVariant="dark"
                  align="end"
                >
                  <NavDropdown.Item as={Link} to="/account">
                    Thông tin tài khoản
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/orders" onClick={(e) => handleProtectedLinkClick(e, '/orders')}>
                    Đơn hàng của tôi
                  </NavDropdown.Item>
                  {user?.role === 'ADMIN' && (
                     <NavDropdown.Item as={Link} to="/admin">Trang quản trị</NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-2"></i> Đăng xuất
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <>
                  <li className="nav-item">
                    <Button
                      variant="link"
                      className="nav-link text-white"
                      onClick={openLoginModal}
                    >
                      <i className="bi bi-person me-1"></i> Đăng nhập
                    </Button>
                  </li>
                </>
              )}
            </ul>
          </div>
        </nav>
      </div>

      {/* Login Modal */}
      <Modal show={showLoginModal} onHide={() => setShowLoginModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Đăng nhập</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loginError && <div className="alert alert-danger">{loginError}</div>}
          {registerSuccess && !loginError && <div className="alert alert-success">{registerSuccess}</div>}
          <Form onSubmit={handleLoginSubmit}>
            <Form.Group className="mb-3" controlId="loginUsername">
              <Form.Label>Tên đăng nhập (Email)</Form.Label>
              <Form.Control
                type="text" 
                placeholder="Nhập tên đăng nhập hoặc email"
                value={loginData.username}
                onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                required
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="loginPassword">
              <Form.Label>Mật khẩu</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nhập mật khẩu"
                value={loginData.password}
                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
              {isLoading ? 'Đang xử lý...' : 'Đăng nhập'}
            </Button>
          </Form>
          <div className="mt-3 text-center">
            <span>Chưa có tài khoản? </span>
            <Button
              variant="link"
              onClick={() => { // THAY ĐỔI: Chuyển sang modal đăng ký
                openRegisterModal();
                setLoginError(''); // Xóa lỗi đăng nhập khi chuyển
              }}
              style={{ padding: 0, verticalAlign: 'baseline' }}
            >
              Đăng ký ngay
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Register Modal */}
      <Modal show={showRegisterModal} onHide={() => setShowRegisterModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Đăng ký tài khoản</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {registerError && <div className="alert alert-danger">{registerError}</div>}
          <Form onSubmit={handleRegisterSubmit}>
            <Form.Group className="mb-3" controlId="registerFullName">
              <Form.Label>Họ và tên</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nhập họ và tên"
                name="fullName"
                value={registerData.fullName}
                onChange={handleRegisterChange}
                required
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="registerEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Nhập địa chỉ email"
                name="email"
                value={registerData.email}
                onChange={handleRegisterChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="registerPassword">
              <Form.Label>Mật khẩu</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nhập mật khẩu (ít nhất 6 ký tự)"
                name="password"
                value={registerData.password}
                onChange={handleRegisterChange}
                required
                minLength={6} 
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="registerConfirmPassword">
              <Form.Label>Xác nhận mật khẩu</Form.Label>
              <Form.Control
                type="password"
                placeholder="Nhập lại mật khẩu"
                name="confirmPassword"
                value={registerData.confirmPassword}
                onChange={handleRegisterChange}
                required
                minLength={6}
              />
            </Form.Group>
            {/* THAY ĐỔI: Thêm trường Phone (tùy chọn) */}
            <Form.Group className="mb-3" controlId="registerPhone">
              <Form.Label>Số điện thoại (Tùy chọn)</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Nhập số điện thoại"
                name="phone"
                value={registerData.phone}
                onChange={handleRegisterChange}
              />
            </Form.Group>
            {/* THAY ĐỔI: Thêm trường Address (tùy chọn) */}
            <Form.Group className="mb-3" controlId="registerAddress">
              <Form.Label>Địa chỉ (Tùy chọn)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nhập địa chỉ"
                name="address"
                value={registerData.address}
                onChange={handleRegisterChange}
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="w-100" disabled={isRegistering}>
              {isRegistering ? 'Đang xử lý...' : 'Đăng ký'}
            </Button>
          </Form>
          <div className="mt-3 text-center">
            <span>Đã có tài khoản? </span>
            <Button
              variant="link"
              onClick={() => { // THAY ĐỔI: Chuyển sang modal đăng nhập
                openLoginModal();
                setRegisterError(''); // Xóa lỗi đăng ký khi chuyển
              }}
              style={{ padding: 0, verticalAlign: 'baseline' }}
            >
              Đăng nhập ngay
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </header>
  );
}

export default Header;